import { call, put, select } from 'redux-saga/effects';

import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IIdItemInfo } from '../../ts/models/resourceInfoParts';
import { Set } from '../../ts/models/Set';
import { DeleteRemoteExtractRefreshAction } from '../actions/DeleteRemoteExtractRefreshAction';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { DeleteRemoteRefreshSchedulesAction } from '../services/DeleteRemoteRefreshSchedulesAction';

export function* handleDeleteRemoteExtractRefreshAction(action: DeleteRemoteExtractRefreshAction) {
  try {
    const datasource: IIdItemInfo = yield select(selectSpaceInfoItem);
    yield call(executeDeleteRemoteExtractRefreshAction, datasource, action.schedules);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeDeleteRemoteExtractRefreshAction(
  datasource: IIdItemInfo,
  items: IRemoteRefreshScheduleInfo[]
) {
  const deleteRemoteExtractRefreshService = DeleteRemoteRefreshSchedulesAction;
  return deleteRemoteExtractRefreshService.execute(datasource, Set.fromIdItemArray(items));
}
